// @flow

import React from 'react';

import Button from 'app/common/components/Button';
import ButtonGroup from 'app/common/components/ButtonGroup';
import FileInput from 'app/common/components/FileInput';
import Modal from 'app/common/components/Modal';
import InfoBlock, {
  InfoBlockDescription,
  InfoBlockTitle,
} from 'app/common/components/InfoBlock';
import { ErrorBar } from 'app/common/components/MessageBar';

type OnCloseProp = () => void;
type OnImportProp = (file: File) => void;

type ZapImportModalProps = {
  error?: string,
  onClose: OnCloseProp,
  onImport: OnImportProp,
  onInvalid: (reason: string) => void,
};

const ZapImportModal = (props: ZapImportModalProps) => {
  const inputId = `zap-import-modal-input-${Date.now()}`;
  const onImport = (file: File) => {
    props.onImport(file);
    props.onClose();
  };
  return (
    <Modal
      closeOnEsc={true}
      closeOnOutsideClick={true}
      contentClassName=""
      isOpened={true}
      kind="narrow"
      onClose={props.onClose}
    >
      <InfoBlock kind="bare centered">
        <InfoBlockTitle>Heads up!</InfoBlockTitle>
        {props.error && <ErrorBar>{props.error}</ErrorBar>}
        <InfoBlockDescription>
          After importing you’ll have to manually turn on all of your imported
          Zaps since some of the connected accounts used in them may need to be
          reconnected.
        </InfoBlockDescription>
        <FileInput
          accept="application/json"
          id={inputId}
          isHidden={true}
          name="zap-import-file"
          onChangeValue={onImport}
          onInvalid={props.onInvalid}
        />
        <ButtonGroup kind="horizontal justify-center">
          <Button kind="secondary large min-width" onClick={props.onClose}>
            Nevermind
          </Button>
          <Button htmlFor={inputId} kind="primary large min-width" tag="label">
            Choose File
          </Button>
        </ButtonGroup>
      </InfoBlock>
    </Modal>
  );
};

type ZapImportModalStatefulProps = {
  onClose: OnCloseProp,
  onImport: OnImportProp,
};

type ZapImportModalStatefulState = {
  error?: string,
};

class ZapImportModalStateful extends React.Component<
  ZapImportModalStatefulProps,
  ZapImportModalStatefulState
> {
  state = { error: undefined };

  onImport = (file: File) => {
    this.setState({ error: undefined });
    this.props.onImport(file);
  };

  onInvalid = (reason: string) => {
    this.setState({ error: reason });
  };

  render() {
    const { props, state } = this;
    return (
      <ZapImportModal
        {...props}
        {...state}
        onImport={this.onImport}
        onInvalid={this.onInvalid}
      />
    );
  }
}

export default ZapImportModalStateful;
